import styled from "styled-components";

import {
  Block,
  Anchor,
} from '../../../styles'

export const ParsedHTMLContainer = styled(Block)`
  --color-red-accent: #db604e;

  a {
    --color-red-accent: #db604e;
    color: var(--color-red-accent);
  }
`
export const ParsedHTMLAnchor = styled(Anchor)`
  --color-red-accent: #db604e;
  color: var(--color-red-accent);
`
